import * as FilesModule from '../../../Modules/FilesModule';
import { Files } from '../EnumTypes/ActionEnumTypes';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { toast } from 'react-toastify';
import SVG from 'Components/SVG';
import { SVG_TYPE } from 'Shared/enums';

const init = () => ({
  type: Files.ADD_TRANSLATED_FILE_INIT,
});

const success = (data: any) => ({
  type: Files.ADD_TRANSLATED_FILE_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Files.ADD_TRANSLATED_FILE_FAILURE,
});

const addTranslatedFile =
  ({ files, orderUuid }) =>
  async (dispatch) => {
    dispatch(init());
    const id = toast.loading('Trwa dodawanie pliku');
    try {
      dispatch(ViewManagementModule.Actions.showLoader());
      const data = await FilesModule.Connector.addTranslatedFile({ files, orderUuid });
      dispatch(success(data));
      // toast.success('Pomyślnie dodano plik', { icon: <SVG variant={SVG_TYPE.CIRCLE_CHECKED} /> });
      toast.update(id, {
        render: 'Pomyślnie dodano plik',
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 3000,
        icon: <SVG variant={SVG_TYPE.CIRCLE_CHECKED} />,
        closeButton: true,
      });

      return data.data;
    } catch (err: any) {
      dispatch(failure());
      // toast.error('Nie udało się dodać pliku', { icon: <SVG variant={SVG_TYPE.CIRCLE_X} /> });
      toast.update(id, {
        render: 'Nie udało się dodać pliku',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 3000,
        icon: <SVG variant={SVG_TYPE.CIRCLE_X} />,
        closeButton: true,
      });
      return false;
    }
  };

export default addTranslatedFile;
